import {closeSearch} from "./SearchBar";
import {changeBackground} from "./MobileHeader";
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

const bodyEl = document.querySelector('body');
const headerEl = document.querySelector('.main-header');
const dropdownTriggerEl = document.querySelector('.main-header__wrapper--desktop .main-header__dropdown-nav .menu > .menu-item-has-children > a');
const dropdownSubmenuAll = document.querySelectorAll('.main-header__wrapper--desktop .main-header__dropdown-nav .menu > .menu-item-has-children .menu-item-has-children > a');

const locale = {
    bodyClass: 'dropdown-header-active',
    activeClass: 'active',
}

const CLOSE = 0;
const OPEN = 1;
let state = CLOSE;

/**
 * Change current open submenu inside dropdown.
 * @param currentTarget
 */
const changeCurrentSubmenu = ({currentTarget}) => {
    event.preventDefault();

    dropdownSubmenuAll.forEach(submenuEl => {
        submenuEl.classList.remove(locale.activeClass);
        submenuEl.nextElementSibling.classList.remove(locale.activeClass);
    })

    currentTarget.classList.add(locale.activeClass);
    currentTarget.nextElementSibling.classList.add(locale.activeClass);
}

/**
 * Close dropdown wrapper.
 */
export const closeDropdown = () => {
    enablePageScroll();

    state = CLOSE;

    bodyEl.classList.remove(locale.bodyClass)
    dropdownTriggerEl.nextElementSibling.classList.remove(locale.activeClass);
}

/**
 * Open dropdown wrapper.
 */
export const openDropdown = () => {
    closeSearch();
    disablePageScroll();
    changeBackground(true);

    state = OPEN;

    bodyEl.classList.add(locale.bodyClass)
    dropdownTriggerEl.nextElementSibling.classList.add(locale.activeClass);
}

/**
 * Logic for toggle dropdown wrapper.
 */
export const toggleDropdown = () => {
    state === CLOSE ? openDropdown() : closeDropdown();
}

/**
 * Initial actions. Add event listeners.
 */
const init = () => {
    if ( dropdownTriggerEl && dropdownSubmenuAll ) {
        dropdownTriggerEl.addEventListener('click', () => {
            event.preventDefault();
            toggleDropdown();
        });
        dropdownSubmenuAll.forEach(dropdownSubmenuEl => {
            dropdownSubmenuEl.addEventListener('click', changeCurrentSubmenu);
        })
    }
}

/**
 * Close dropdown if click event is out of header.
 * @param target
 */
export const hideDropdownOutsideClick = ({target}) => {
    if ( !(target === headerEl || headerEl.contains(target)) ) {
        closeDropdown();
    }
}

export default init;
